export default {
  get: (): string[] => (localStorage.getItem("roles") !== "undefined"
    ? JSON.parse(localStorage.getItem("roles") || "")
    : []),
  set: (roles: string[]): void => localStorage.setItem("roles", JSON.stringify(roles)),
  setId: (id: string): void => localStorage.setItem("id", id),
  getId: (): string => localStorage.getItem("id") ?? "",
  clear: (): void => localStorage.removeItem("roles"),
};
